
import PropTypes from 'prop-types';
import { useEffect, useState } from 'react';
import { Col, Form, Row } from 'react-bootstrap';
import { formatBalance, numberToLocalForm, removeCommaFromNumString } from '../../utils/common';

const TermForm = ({ element, termInfo, handleChange }) => {
  const [showError, setShowError] = useState(false);

  useEffect(() => {
    if (!element?.selectedTerm?.apy && element?.selectedTerm?._id) {
      const t = Object.keys(termInfo).length > 0 ? termInfo : [];
      const selectedItem = t.find((item) => item?._id === element?.selectedTerm?._id);
      if (selectedItem) {
        const question = { ...element, selectedTerm: selectedItem };
        handleChange({}, question);
      }
    }
  }, [termInfo]);

  const handleTermChange = (event) => {
    const selectedItem = termInfo?.find((item) => item?._id === event.target.value);
    let question = { ...element, selectedTerm: selectedItem };
    if (question?.userInput === '') {
      setShowError(true);
      question = { ...element, selectedTerm: selectedItem, validationError: true };
    }
    handleChange(event, question);
  };

  const handleIsNumberDemcimal = (e) => {
    const val = removeCommaFromNumString(e.target.value);
    const selctedTerm = element?.selectedTerm || termInfo[0];
    const minBal = parseFloat(selctedTerm?.minBalance);
    const maxBal = parseFloat(selctedTerm?.maxBalance);
    const cdAmount = parseFloat(val);
    let question = element;
    if ((minBal <= cdAmount && maxBal >= cdAmount && maxBal > 0) || (minBal <= cdAmount && maxBal === 0)) {
      setShowError(false);
      question = { ...question, userInput: val, validationError: false };
    } else {
      setShowError(true);
      question = { ...question, userInput: val, validationError: true };
    }
    handleChange(e, question);
  };

  const cdTerms = element?.selectedTerm || termInfo[0];
  return (
    <div className='term-form-wrapper'>
      <div className="d-flex termHeading">
        <div className="w-100">
          <Row>
            <Col sm={12} md={6}>
              <span className="fs-12 question">CD Amount ( $ )</span>
              <span className="text-danger"> *</span>
              <input
                className="zipText fs-13 answer"
                type="text"
                name={'cdAmount'}
                maxLength={11}
                required="true"
                value={numberToLocalForm(element?.userInput)}
                onChange={(e) => handleIsNumberDemcimal(e)}
                onInput={(e) => {
                  if (e.target.value.length > 11) {
                    e.target.value = e.target.value.slice(0, 11);
                  }
                }}
              />
              {showError && (
                <span className="text-danger fs-12">
                  CD Amount should be between {formatBalance(cdTerms?.minBalance, '', false)} to{' '}
                  {formatBalance(cdTerms?.maxBalance, '', false)}
                </span>
              )}
            </Col>
            <Col>
              <div>
                <span className="fs-12 question">CD Terms ( Month )</span>
                <Form.Select
                  name="cdTerms"
                  className={`formSelectors fs-13 answer`}
                  value={cdTerms?._id}
                  onChange={(e) => handleTermChange(e, element?.question)}
                >
                  {termInfo?.length > 0 &&
                    termInfo?.map((list) => {
                      // const label = configureLabel(list?.terms, list?.termInMonths, list?.apy);
                      return (
                        <option key={list?._id} value={list?._id}>
                          {list?.label || list?.terms || list?.termInMonths}
                        </option>
                      );
                    })}
                </Form.Select>
              </div>
            </Col>
          </Row>
        </div>
      </div>
    </div>
  );
};

TermForm.propTypes = {
  element: PropTypes.object,
  handleChange: PropTypes.func.isRequired,
  termInfo: PropTypes.array.isRequired,
};
export default TermForm;
